module.exports = __webpack_public_path__ + "assets/u45.da36a77e.svg";